import { render } from "./index.vue?vue&type=template&id=9e51683a&scoped=true&bindings={\"show\":\"data\",\"lastStepHasSelectedItems\":\"data\",\"questionsConfig\":\"options\",\"questions\":\"options\",\"activeStep\":\"options\",\"selection\":\"options\",\"isLastStep\":\"options\",\"programs\":\"options\",\"complete\":\"options\",\"displayQuestions\":\"options\",\"availableQuestions\":\"options\",\"nextStep\":\"options\",\"showStep\":\"options\",\"setStepSelectedItems\":\"options\",\"scrollToElement\":\"options\"}"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=9e51683a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9e51683a"

export default script